/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable prettier/prettier */
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import MDTypography from "components/MDTypography";
import { makeStyles } from "@mui/styles";
import COLORS from "constant/colors";
import logoPraps from "assets/images/identite/logoPraps.png";
import logoCirad from "assets/images/identite/logoCirad2.png";
import { CURRENT_ZONE } from "constant";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
    banner: {
        backgroundColor: "#2196f3",
        color: "#fff",
        padding: theme.spacing(2),
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    bannerImage: {
        maxWidth: "100%",
        height: "auto",
        width: "100%",
    },

    logoSigninRow: {
        display: "flex",
        justifyContent: "center", // Centre l'image horizontalement
        alignItems: "center",
        marginTop: 15,
        // backgroundColor: "red",
    },

    logoClient: {
        width: "10%",
        height: "auto" /* Maintain aspect ratio */,
        // marginTop: 15,
    },
}));
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function HeaderMPSA() {
    const classes = useStyles();
    const { i18n } = useTranslation();
    const { t } = useTranslation("translation");
    const [clientLogo, setClientLogo] = useState("");
    const [title, setTitle] = useState("");
    useEffect(() => {
        if (CURRENT_ZONE === "OI") {
            setClientLogo(logoCirad);
            setTitle(t("MPSA_OI"));
        } else if (CURRENT_ZONE === "SAHEL") {
            setClientLogo(logoPraps);
            setTitle(t("MPSA_Sahel"));
        }
    }, [i18n.resolvedLanguage]);
    return (
        <div>
            <Box
                className={classes.logoSigninRow}
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
                gap={2} // Ajoute un espacement entre l'image et le texte
                sx={{
                    // backgroundColor: "red",
                    flexDirection: { xs: "column", md: "row" }, // Colonne sur petits écrans et ligne sur grands écrans
                }}
            >
                <img
                    src={clientLogo}
                    alt="Logo"
                    className={classes.logoClient}
                    style={{ maxWidth: "100%", height: "auto" }} // Rend l'image responsive
                />
                <MDTypography
                    variant="h2"
                    fontWeight="medium"
                    sx={{ color: COLORS.primary, textAlign: "center", marginTop: { md: 1 } }} // Centre le texte sur petits écrans
                >
                    {title}
                </MDTypography>
            </Box>
        </div>
    );
}

export default HeaderMPSA;
